


























import {Component, Vue} from 'vue-property-decorator'
import {Getter} from 'vuex-class'
import {StoreNamespace} from '../../../../globals/StoreNamespaceGlobal'
import {CompanyDetailsResponse} from '@payroll/optimus-common'

@Component
export default class SuccessLogout extends Vue {

    @Getter('customerDetails', StoreNamespace.AUTHENTICATION) customerDetails!: CompanyDetailsResponse

}
